import type { Element } from 'slate';

import * as rdmd from '@readme/markdown-legacy';

const serializeForNow = (node: Element, { inline = false, renderingLibrary = rdmd } = {}) => {
  const text = 'mdx' in renderingLibrary ? renderingLibrary.mdx(node).trim() : renderingLibrary.md(node).trim();

  return inline ? { text } : { type: 'paragraph', children: [{ text }] };
};

export default serializeForNow;
